// extracted by mini-css-extract-plugin
module.exports = {"vault":"Vault_vault__3oJ53","title":"Vault_title__1T6qV","none":"Vault_none__gr33U","topPart":"Vault_topPart__25A9X","icon":"Vault_icon__1_NLB","cards":"Vault_cards__3GfW0"};